module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10AXxH7/tc-custom/9780547564012.jpg?1720120987009",
      "alt": "This image is the cover for the book Diary of Anaïs Nin, 1944–1947, The Diaries of Anaïs Nin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Diary of Anaïs Nin, 1944–1947, The Diaries of Anaïs Nin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The fourth volume of ")]), _c('b', [_vm._v("“one of the most remarkable diaries in the history of letters” ("), _c('i', [_vm._v("Los Angeles Times")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The renowned diarist continues her record of her personal, professional, and artistic life, recounting her experiences in Greenwich Village for several years in the late 1940s, where she defends young writers against the Establishment—and her trip across the country in an old Ford to California and Mexico."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[Nin is] one of the most extraordinary and unconventional writers of [the twentieth] century.” —"), _c('i', [_vm._v("The New York Times Book Review")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Edited and with a preface by Gunther Stuhlmann\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anaïs Nin, Gunther Stuhlmann\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Anaïs Nin (1903–1977) was born in Paris and aspired at an early age to be a writer. An influential artist and thinker, she was the author of several novels, short stories, critical studies, a collection of essays, two volumes of erotica, and nine published volumes of her diary.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0